
import { createSelector } from 'reselect';

const demo = ({ router }) =>  router.location.pathname;
const productState = ({ emissionsDemo }) => emissionsDemo.state;

/**
 * Get the selected Demo
 */
export const getDemo = createSelector([demo], (
    demo,
) => {
    if (demo.includes('emissions')) return 'emissions'
    if (demo.includes('forecast')) return 'forecast'
    if (demo.includes('retina')) return 'retina'
});

/**
 * Get the selected marker
 */
export const getMarker = createSelector([productState], (
    product,
) => {
    if (!product.city) return null;

    return [parseFloat(product.city.location.lat), parseFloat(product.city.location.long)]
});



// WEBPACK FOOTER //
// ./src/components/map/selectors.js